import { render, staticRenderFns } from "./BasePageWrapper.vue?vue&type=template&id=fa2c1716&"
import script from "./BasePageWrapper.vue?vue&type=script&lang=js&"
export * from "./BasePageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BasePageWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports